import { render } from "./tw-image.vue?vue&type=template&id=b5e6dc82"
import script from "./tw-image.vue?vue&type=script&lang=js"
export * from "./tw-image.vue?vue&type=script&lang=js"
script.render = render

export default script